// src/components/fraud/ReinstateConfirmDialog.js
// Confirmation dialog before reinstating a suspended user.
// Same visual pattern as BlacklistDeleteConfirm but with green accent.

import React from 'react';
import { Modal } from 'react-bootstrap';

const ReinstateConfirmDialog = ({ open, user, onClose, onConfirm, opLoading }) => {
  if (!user) return null;
  return (
    <Modal show={open} onHide={onClose} centered backdrop={opLoading ? 'static' : true} size="sm">
      <div style={{ background: 'var(--bg-surface)', border: '1px solid rgba(34,197,94,0.25)', borderRadius: 12, overflow: 'hidden' }}>

        {/* Header */}
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '18px 20px', borderBottom: '1px solid var(--divider)' }}>
          <span style={{ fontSize: 20 }}>✓</span>
          <div>
            <h6 style={{ margin: 0, fontWeight: 700, color: '#22C55E', fontSize: 14 }}>Reinstate User</h6>
            <small style={{ color: 'var(--text-secondary)', fontSize: 11 }}>This will restore the user's access</small>
          </div>
        </div>

        {/* Body */}
        <div style={{ padding: '20px' }}>
          <p style={{ color: 'var(--text-primary)', fontSize: 13, marginBottom: 14 }}>
            Confirm you want to reinstate this suspended user?
          </p>

          {/* User summary */}
          <div style={{ background: 'rgba(34,197,94,0.06)', border: '1px solid rgba(34,197,94,0.2)', borderRadius: 8, padding: '12px 14px', marginBottom: 4 }}>
            <div style={{ fontSize: 13, fontWeight: 700, color: 'var(--text-primary)', marginBottom: 2 }}>
              {user.name || '(no name)'}
            </div>
            <div style={{ fontSize: 12, color: 'var(--text-secondary)', marginBottom: 2 }}>{user.email}</div>
            {user.phoneNumber && (
              <div style={{ fontSize: 11, color: 'var(--text-secondary)' }}>{user.phoneNumber}</div>
            )}
          </div>
          <small style={{ fontSize: 11, color: 'var(--text-secondary)' }}>
            This sets status → Active and clears suspendedAt, suspendedBy, suspensionReason.
          </small>
        </div>

        {/* Footer */}
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 10, padding: '14px 20px', borderTop: '1px solid var(--divider)' }}>
          <button
            onClick={onClose} disabled={opLoading}
            style={{ background: 'transparent', border: '1px solid rgba(255,255,255,0.15)', borderRadius: 8, color: 'var(--text-secondary)', fontSize: 13, fontWeight: 600, padding: '7px 16px', cursor: 'pointer' }}
          >
            Cancel
          </button>
          <button
            id="reinstate-confirm-btn"
            onClick={() => onConfirm(user.uid)}
            disabled={opLoading}
            style={{ background: '#22C55E', border: 'none', borderRadius: 8, color: '#050014', fontSize: 13, fontWeight: 700, padding: '7px 20px', cursor: opLoading ? 'default' : 'pointer', minWidth: 100, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6 }}
          >
            {opLoading
              ? <span className="admin-loader-sm" style={{ borderTopColor: '#050014' }} />
              : 'Reinstate'
            }
          </button>
        </div>

      </div>
    </Modal>
  );
};

export default ReinstateConfirmDialog;
